import React from "react";

const SvgComponent = props => (
  <svg width={52.045} height={26.648} viewBox="0 0 52.045 26.648" {...props}>
    <path
      d="M46.119 7.799c-1.287-5.301-6.246-5.569-7.638-5.195C36.976 1.102 34.463 0 31.924 0a9.551 9.551 0 0 0-7.699 3.892c-2.029-1.593-4.926-2.693-7.854-2.693-6.703 0-12.195 5.182-12.689 11.76a7.333 7.333 0 0 0 3.652 13.69h28.281a7.542 7.542 0 0 0 7.541-7.53h3.225a5.664 5.664 0 0 0 5.664-5.663s.026-5.657-5.926-5.657zM35.621 23.841H7.969c-2.738 0-4.76-1.982-4.76-4.547 0-2.094 1.33-3.933 3.41-4.56.246-9.9 8.943-10.406 9.91-10.406 2.873 0 5.725 1.408 7.559 3.495 3.709-1.219 8.791 1.643 8.224 7.17 1.446-.586 2.896-.541 3.311-.541 2.076 0 4.588 1.818 4.588 4.801a4.591 4.591 0 0 1-4.59 4.588zm10.764-6.832h-3.553c-.615-2.228-2.396-5.429-7.563-5.429-1.361-5.611-5.816-6.986-8.515-7.063 2.031-2.011 4.83-2.165 5.289-2.165 2.158 0 4.299 1.059 5.679 2.625 2.784-.915 6.604 1.232 6.176 5.386 1.088-.439 2.178-.405 2.487-.405 1.56 0 3.445 1.366 3.445 3.605a3.445 3.445 0 0 1-3.445 3.446z"
      fill="#83a5b3"
    />
  </svg>
);

export default __webpack_public_path__ + "static/media/04d.d0ca9a39.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/weather-icons/04d.svg